import { render, staticRenderFns } from "./BaseBackToTop.vue?vue&type=template&id=70b055bc&"
import script from "./BaseBackToTop.vue?vue&type=script&lang=js&"
export * from "./BaseBackToTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports